/* eslint-disable */
import React from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

// is swapping numerator with denominator: 2/3 => 3/2
var getReciprocal = function (number) { return (number === 0 ? 0 : number / (number * number)); };

var TestIds;
(function (TestIds) {
    TestIds["MainWrapper"] = "MainWrapper";
    TestIds["HeightWrapper"] = "HeightWrapper";
    TestIds["ItemWidthWrapper"] = "ItemWidthWrapper";
    TestIds["ItemWrapper"] = "ItemWrapper";
    TestIds["Item"] = "Item";
    TestIds["ItemInside"] = "ItemInside";
})(TestIds || (TestIds = {}));
var fixedRatioWrapperStyles = function (_a) {
    var ratio = _a.ratio;
    return ({
        width: '100%',
        paddingBottom: "calc(100% / " + ratio + ")",
        position: 'relative',
    });
};
var itemInsideStyles = function () { return ({
    position: 'absolute',
    width: '100%',
    height: '100%',
}); };
var itemStyles = function (_a) {
    var ratio = _a.ratio;
    return (__assign({}, fixedRatioWrapperStyles({ ratio: ratio }), { display: 'block', bottom: 0, pointerEvents: 'auto', position: 'absolute' }));
};
var itemWrapperStyles = function (_a) {
    var ratio = _a.ratio;
    return (__assign({}, fixedRatioWrapperStyles({ ratio: ratio }), { top: 0 }));
};
var itemWidthWrapperStyles = function (_a) {
    var width = _a.width, left = _a.left;
    return ({
        position: 'absolute',
        width: width * 100 + "%",
        left: left * 100 + "%",
    });
};
var heightWrapperStyles = fixedRatioWrapperStyles;
var mainWrapperStyles = function (_a) {
    var gutter = _a.gutter;
    return ({
        margin: "0 " + (gutter / 2) * 100 + "%",
        pointerEvents: 'none',
    });
};
var getMoorageStyles = function (_a) {
    var itemsRatios = _a.itemsRatios, gutter = _a.gutter, nrOfColumns = _a.nrOfColumns;
    var columnsRatios = Array.from(Array(nrOfColumns)).map(function () { return 0; });
    var columnsNrOfItems = Array.from(Array(nrOfColumns)).map(function () { return 0; });
    var columnSideGutter = gutter / (1 - gutter);
    var columnVerticalGutter = gutter / ((1 - gutter) / nrOfColumns);
    var inversedVerticalGutterRatio = columnVerticalGutter / 1;
    var itemsCoordinates = itemsRatios.map(function (itemRatio) {
        var _a = columnsRatios.reduce(function (_a, columnRatio, columnIndex) {
            var shortestColumnIndex = _a[0], shortestColumnRatio = _a[1];
            return getReciprocal(columnRatio) < getReciprocal(shortestColumnRatio)
                ? [columnIndex, columnRatio]
                : [shortestColumnIndex, shortestColumnRatio];
        }, [0, columnsRatios[0]]), shortestColumnIndex = _a[0], shortestColumnRatio = _a[1];
        var left = (1 / nrOfColumns) * shortestColumnIndex + columnSideGutter / 2;
        var columnWidth = 1 / nrOfColumns - columnSideGutter;
        var inversedShortesedColumnRatio = getReciprocal(shortestColumnRatio);
        var inversedRatio = getReciprocal(itemRatio);
        var inversedRatioSum = inversedShortesedColumnRatio + inversedRatio + inversedVerticalGutterRatio;
        var wrapperRatio = getReciprocal(inversedRatioSum);
        var orderIndexInColumn = columnsNrOfItems[shortestColumnIndex];
        columnsRatios[shortestColumnIndex] = wrapperRatio;
        columnsNrOfItems[shortestColumnIndex] += 1;
        return {
            wrapperRatio: wrapperRatio,
            itemRatio: itemRatio,
            left: left,
            columnWidth: columnWidth,
            orderIndexInColumn: orderIndexInColumn,
        };
    });
    var tallestColumnRatio = columnsRatios.reduce(function (tallestColumnRatio, columnRatio) {
        return getReciprocal(columnRatio) > getReciprocal(tallestColumnRatio) ? columnRatio : tallestColumnRatio;
    }, columnsRatios[0]);
    var tallestColumnRatioWithBottomGutter = getReciprocal(getReciprocal(tallestColumnRatio) + inversedVerticalGutterRatio);
    var columnWidthPercentage = (1 - nrOfColumns * gutter) / nrOfColumns;
    var heightWrapperRatio = 1 / (columnWidthPercentage / tallestColumnRatioWithBottomGutter);
    return {
        mainWrapperStyles: mainWrapperStyles({ gutter: gutter }),
        heightWrapperStyles: heightWrapperStyles({ ratio: heightWrapperRatio }),
        itemsStyles: itemsCoordinates.map(function (itemCoordinates) { return ({
            itemWidthWrapperStyles: itemWidthWrapperStyles({
                width: itemCoordinates.columnWidth,
                left: itemCoordinates.left,
            }),
            itemWrapperStyles: itemWrapperStyles({ ratio: itemCoordinates.wrapperRatio }),
            itemStyles: itemStyles({ ratio: itemCoordinates.itemRatio }),
            itemInsideStyles: itemInsideStyles(),
        }); }),
    };
};
var Moorage = function (_a) {
    var items = _a.items, ItemComponent = _a.itemComponent, itemsRatios = _a.itemsRatios, gutter = _a.gutter, nrOfColumns = _a.nrOfColumns;
    var _b = getMoorageStyles({
        itemsRatios: itemsRatios,
        gutter: gutter,
        nrOfColumns: nrOfColumns,
    }), mainWrapperStyles = _b.mainWrapperStyles, heightWrapperStyles = _b.heightWrapperStyles, itemsStyles = _b.itemsStyles;
    return (React.createElement("div", { "data-testid": TestIds.MainWrapper, style: mainWrapperStyles },
        React.createElement("div", { "data-testid": TestIds.HeightWrapper, style: heightWrapperStyles }, itemsStyles.map(function (itemStyles, index) { return (React.createElement("div", { "data-testid": TestIds.ItemWidthWrapper, key: index, style: itemStyles.itemWidthWrapperStyles },
            React.createElement("div", { "data-testid": TestIds.ItemWrapper, style: itemStyles.itemWrapperStyles },
                React.createElement("div", { "data-testid": TestIds.Item, style: itemStyles.itemStyles },
                    React.createElement("div", { "data-testid": TestIds.ItemInside, style: itemStyles.itemInsideStyles },
                        React.createElement(ItemComponent, { item: items[index] })))))); }))));
};

export { Moorage };
